import React from "react";
import StarList from "../components/star/StarList";

const Star = () => {
  return (
    <>
      <StarList />
    </>
  );
};

export default Star;
